import * as React from "react";
import { Formik, Form } from "formik";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Col, Row } from "components/bootstrap";
import SectionComponent from "components/common/Section/SectionComponent";
import NameFormGroup from "../form/NameFormGroup";
import DescriptionFormGroup from "../form/DescriptionFormGroup";
import TeamsDomain from "../../domainActions/TeamsDomain";
import { teamQueryKey } from "../../hooks/useTeam";
const _updateTeam = (team, { name, description }) => {
  const newTeam = team.toBuilder().name(name).description(description).build();
  return TeamsDomain.update(newTeam);
};
const ProfileSection = ({ team }) => {
  const { name, description } = team;
  const queryClient = useQueryClient();
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: "Profile" }, /* @__PURE__ */ React.createElement(
    Formik,
    {
      onSubmit: (data) => _updateTeam(team, data).then(() => queryClient.invalidateQueries({ queryKey: teamQueryKey(team.id) })),
      initialValues: { name, description }
    },
    ({ isSubmitting, isValid }) => /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(NameFormGroup, null), /* @__PURE__ */ React.createElement(DescriptionFormGroup, null), /* @__PURE__ */ React.createElement(Row, { className: "no-bm" }, /* @__PURE__ */ React.createElement(Col, { xs: 12 }, /* @__PURE__ */ React.createElement("div", { className: "pull-right" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", disabled: isSubmitting || !isValid, title: "Update Profile", type: "submit" }, "Update Profile")))))
  ));
};
export default ProfileSection;
